import { FC, useMemo } from 'react';
import { useMethods } from '@lhb/hook';
import styles from '../index.module.less';
import { Button } from 'antd';


/**
 * 预测横幅
 * @description
 * @demo
 */
const Component:FC<{
  /** 类型：1 街边店，2 商场店 */
  type: 1 | 2;
  /** 评分 */
  score: number | string;
}> = ({
  type = 1,
  score = 0,
}) => {

  /* state */

  const text = useMemo(() => {
    const targetScore = Number(score);
    if (Number.isNaN(targetScore) || targetScore < 50) {
      return '';
    }

    if (type === 1) {
      if (targetScore > 85 && targetScore <= 100) {
        return '周边大数据表现优异，开店成功率高，建议结合客流数据测算盈利空间，锁定优质铺位。';
      }
      if (targetScore > 75 && targetScore <= 85) {
        return '周边大数据表现良好，具备高盈利潜力，建议结合点位详细信息，精准测算进店成本与预期营收，确认开店可行性。';
      }
      if (targetScore > 70 && targetScore <= 75) {
        return '周边大数据综合条件优秀，存在明确盈利机会，建议结合点位客流数据，进一步验证回本周期与经营风险';
      }
      if (targetScore > 65 && targetScore <= 70) {
        return '周边大数据基础条件达标，需优质点位才能突围，建议输入点位详细测评。';
      }
      if (targetScore > 50 && targetScore <= 65) {
        return '周边大数据支撑不足，经营风险较高，建议优先更换备选点位或深度测评。';
      }
      // 特殊情况: targetScore = 50 返回空
      return '';
    } else if (type === 2) {
      if (targetScore > 85 && targetScore <= 100) {
        return '商场综合氛围优异，开店成功率高，建议结合商场客流、铺位租金等数据测算盈利空间，优先锁定优质铺位。';
      }
      if (targetScore > 75 && targetScore <= 85) {
        return '商场综合氛围良好，具备高盈利潜力，建议结合铺位位置、进店成本与预期营收做精准测算，确认开店可行性。';
      }
      if (targetScore > 70 && targetScore <= 75) {
        return '商场综合氛围优秀，存在明确盈利机会，建议结合商场客流数据，进一步验证回本周期与经营风险。';
      }
      if (targetScore > 65 && targetScore <= 70) {
        return '商场综合氛围达标，需优质铺位才能突围，建议输入铺位详细信息进行深度测评。';
      }
      if (targetScore > 50 && targetScore <= 65) {
        return '商场综合氛围不足，经营风险较高，建议优先更换商场或备选铺位，或输入铺位详情做深度评估。';
      }
      // 特殊情况: targetScore = 50 返回空
      return '';
    }
    return '';
  }, [score, type]);

  /* hooks */

  /* methods */
  const methods = useMethods({

    handlePredict() {
      window.open('https://single.locxx.ai');
    },

  });

  if (!text) {
    return null;
  }

  return (<div className={styles.predictingBanner}>
    <div className={styles.left}>
      <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/spotevaluation/predicting_banner_icon.png`} className={styles.iconImg} />
      <div className={styles.tip}>{text}</div>
    </div>
    <Button type='primary' className={styles.predictBtn} onClick={methods.handlePredict}>立即预测</Button>
  </div>);
};

export default Component;
